export default __webpack_public_path__ + "static/yuuLogoWhite-4d0bc6295a0255b2c65e4eed8cca902a.svg";